import { cn } from "@/lib/utils";

const TONES = {
  action: "border-action-border bg-action-soft text-action-strong",
  success: "border-success-border bg-success-soft text-success-strong",
  danger: "border-danger-border bg-danger-soft text-danger",
} as const;

/** Statut daté : traitement typographique, sans effet de cachet administratif. */
export function Stamp({
  label,
  date,
  tone = "action",
  className,
}: {
  label: string;
  date: string;
  tone?: keyof typeof TONES;
  className?: string;
}) {
  return (
    <span className={cn(
      "inline-flex flex-wrap items-center gap-x-2 gap-y-1 rounded-md border px-3 py-2 text-ui",
      TONES[tone],
      className,
    )}>
      <span className="font-semibold">{label}</span>
      <span aria-hidden="true">·</span>
      <span className="font-mono font-medium tabular-nums">{date}</span>
    </span>
  );
}
